import './about.scss'

export default function About() {
  return (
    <div id="about">
      <h1>hi, i'm peter</h1>
      <p>and I'm a website developer based in the Twin Cities. I've been building quality, mobile friendly websites for over 10 years. Together with my graphic designer we will work tirelessly to build you the website of your dreams. Here at Minnedev we specialize in Wedding and personal websites. We also offer e-commerce options for easy online selling of goods. Whatever web services you're looking for, Minnedev can help you!</p>
    </div>
  )
}